import React from 'react';

export default function Contact() {
  return (
    <>
      {/* LOCATION */}
      <section className="location" id="location" style={{ paddingTop: 72 }}>
        <div className="location-grid">
          <div className="location-map">
            <div className="map-placeholder">
              <div className="map-pin">📍</div>
              <strong style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, color: 'var(--gold-pale)' }}>
                KayaSparsha Wellness
              </strong>
              <p style={{ color: 'var(--text-mid)' }}>Kengeri Satellite Town, Bangalore</p>
              <a
                href="https://share.google/daZTe2LIGUGg8G6HQ"
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginTop: 16, padding: '10px 24px', background: 'var(--forest)', color: 'var(--gold-pale)', textDecoration: 'none', fontSize: 12, letterSpacing: 1.5, textTransform: 'uppercase' }}
              >
                Open in Maps →
              </a>
            </div>
          </div>
          <div className="location-info">
            <p className="section-label">Find Us</p>
            <h2 className="section-title">
              Visit the<br /><em>Clinic</em>
            </h2>
            <div className="location-details">
              <div className="loc-item">
                <div className="loc-icon">📍</div>
                <div className="loc-text">
                  <h4>Address</h4>
                  <p>Kayasparsha Ayurvedic Wellness Center<br />5, 1st Main, Shirke Main Rd, MTS Layout<br />Kengeri Satellite Town, Bengaluru – 560060, Karnataka</p>
                </div>
              </div>
              <div className="loc-item">
                <div className="loc-icon">🕐</div>
                <div className="loc-text">
                  <h4>Clinic Hours</h4>
                  <p>Monday – Saturday: 8:00 AM – 8:00 PM<br />Sunday: By Appointment Only</p>
                </div>
              </div>
              <div className="loc-item">
                <div className="loc-icon">📞</div>
                <div className="loc-text">
                  <h4>Contact</h4>
                  <p>+91 96062 09376<br />support@kayasparsha.com</p>
                </div>
              </div>
              <div className="loc-item">
                <div className="loc-icon">🚇</div>
                <div className="loc-text">
                  <h4>How to Reach</h4>
                  <p>Nearest Metro: Kengeri Station (Purple Line)<br />Parking available on premises</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
